import MemberPhoto from "./components/member_photo";

const data = [
  {
    name: "Claudia A. García",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/claudia-centrocentro.jpg",
  },
  {
    name: "Yaroslav A. Volkov",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/yaros-centrocentro.jpg",
  },
  {
    name: "Brenda Jiménez",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/brenda-centrocentro.jpg",
  },
  {
    name: "Mirelle Culebro",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/mirelle-centrocentro.jpg",
  },
  {
    name: "José Antonio Muñoz",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/antonio-mu-oz-team.jpg",
  },
  {
    name: "Sergio García",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/sergio-centrocentro.jpg",
  },
  {
    name: "Rodrigo Labastida",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/rodrigo-centrocentro.jpg",
  },
  {
    name: "Andrea de los Santos",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/andrea-centrocentro.jpg",
  },
  {
    name: "Lizeth Cameras",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/lizeth-centrocentro.jpg",
  },
  {
    name: "Audrey Hevia",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/audrey-centrocentro.jpg",
  },
  {
    name: "Melchor A. Soto",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/melchor-centrocentro.jpg",
  },
  {
    name: "Ana Sofía Centeno",
    imgUrl:
      "https://static.igem.wiki/teams/4260/wiki/anasofia-centrocentro.jpg",
  },
  {
    name: "Karen I. Marín",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/karen-centrocentro.jpg",
  },
  {
    name: "Amanda Spínola",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/amanda-centrocentro.jpg",
  },
  {
    name: "Ariadna Alonso",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/ariadna-centrocentro.jpg",
  },
  {
    name: "Amiel J. Rosete",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/amiel-centrocentro.jpg",
  },
  {
    name: "Valeria Torres",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/valeria-torres-team.jpg",
  },
  {
    name: "Isabel Hernández",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/isa-centrocentro.jpg",
  },
  {
    name: "Héctor A. Munro",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/hector-centrocentro.jpg",
  },
  {
    name: "Humberto Carrillo",
    imgUrl:
      "https://static.igem.wiki/teams/4260/wiki/humberto-centrocentro.jpg",
  },
  {
    name: "Saúl Higareda",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/saul-centrocentro.jpg",
  },
  {
    name: "Regina Rivas",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/regina-centrocentro.jpg",
  },
  {
    name: "Jennifer Rivera",
    imgUrl:
      "https://static.igem.wiki/teams/4260/wiki/jennifer-centrocentro.jpg",
  },
  {
    name: "Ximena Quintero",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/ximena-centrocentro.jpg",
  },
  {
    name: "Rebeca Patiño",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/rebeca-centrocentro.jpg",
  },
  {
    name: "Ana Paula Martínez",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/anapau-team.jpg",
  },
  {
    name: "José Gerardo Altamirano",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/jerry-centrocentro.jpg",
  },
  {
    name: "Salvador Chávez",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/salvador-chavez-team.jpg",
  },
  {
    name: "Arturo Ortíz",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/arturo-ortiz-team.jpg",
  },

];

const visualsTeam = [
  {
    name: "Sofía Azamar",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/sofi-centrocentro.jpg",
  },
  {
    name: "Selma M. Martínez",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/selma-centrocentro.jpg",
  },
  {
    name: "Itcel Ortega",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/itcel-centrocentro.jpg",
  },
  {
    name: "Minerva Zamudio",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/minerva-centrocentro.jpg",
  },
  {
    name: "Sara S. Hernández",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/sara-centrocentro.jpg",
  },
  {
    name: "Dino Hernández",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/dino-centrocentro.jpg",
  },
  {
    name: "Zyanya Rojas",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/zyan-centrocentro.jpg",
  },
  {
    name: "Valeria G. Zúñiga",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/valeria-centrocentro.jpg",
  },
  {
    name: "Daniela Mejía",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/dani-team.jpg",
  },
];

const professors = [
  {
    name: "PhD. Ana Laura Torres",
    imgUrl:
      "https://static.igem.wiki/teams/4260/wiki/analaura-centrocentro.jpg",
  },
  {
    name: "PhD. Aurora Antonio P.",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/aurora-centrocentro.jpg",
  },
  {
    name: "PhD. Dulce V. Melo",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/ddulce-centrocentro.jpg",
  },
  {
    name: "PhD. Cesar García",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/cesar-centrocentro.jpg",
  },
  {
    name: "M.S Roberto Delgado",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/roberto-centrocentro.jpg",
  },
  {
    name: "PhD. Elías Octavio Gómez",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/elias-centrocentro.jpg",
  },
  {
    name: "PhD. Carlos E. Gómez",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/carlos-centrocentro.jpg",
  },
  {
    name: "Biol. Ramón E. Rivero",
    imgUrl: "https://static.igem.wiki/teams/4260/wiki/ramon-centrocentro.jpg",
  },
  {
    name: "PhD. María Guadalupe Pérez L.",
    imgUrl:
      "https://static.igem.wiki/teams/4260/wiki/team-lupita-proffessor.jpeg",
  },
];

export default function TeamPage() {
  return (
    <div
      className="hero pt-20"
      style={{
        backgroundImage: `url(https://static.igem.wiki/teams/4260/wiki/imagen/team/team-page-bg.png)`,
        minHeight: 200,
      }}
    >
      <div className="p-10 text-center">
        <h1
          className=" text-5xl text-white pb-4"
          style={{ fontFamily: "Cano" }}
        >
          Our Team
        </h1>
        {data.map(function (value) {
          return <MemberPhoto name={value.name} imgUrl={value.imgUrl} />;
        })}
        <h1
          className=" text-5xl text-white pt-12"
          style={{ fontFamily: "Cano" }}
        >
          Visuals
        </h1>
        <h3
          className="text-white text-xl"
          style={{ color: "rgb(175,247,255)" }}
        >
          Tec de Monterrey's Art & Design Company
        </h3>
        {visualsTeam.map(function (value) {
          return <MemberPhoto name={value.name} imgUrl={value.imgUrl} />;
        })}
        <h1
          className=" text-5xl text-white pt-12"
          style={{ fontFamily: "Cano" }}
        >
          Professors
        </h1>
        {professors.map(function (value) {
          return <MemberPhoto name={value.name} imgUrl={value.imgUrl} />;
        })}
      </div>
    </div>
  );
}
